module.exports = __webpack_public_path__ + "img/plan.34e81c3f.png";